<template>
  <div style="width:100%; padding-top: 60px">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
        <screenButton class="screenButton"></screenButton>
      </div>
    </div>

    <b-table class="bgc-dark" head-variant="dark" responsive bordered
             :items="items" :fields="fields1">
      <template #thead-top="data">
        <b-tr>
          <b-th colspan="6" style="text-align: center"></b-th>
          <b-th colspan="2" style="text-align: center">采购信息</b-th>
          <b-th colspan="2" style="text-align: center"></b-th>
        </b-tr>
      </template>
      <template v-slot:head()="scope">
        <div class="text-nowrap" style="text-align:center; vertical-align: middle;">
          {{ scope.label }}
        </div>
      </template>
      <template v-slot:cell(index)="data">
        {{ data.index + 1 }}
      </template>

      <template v-slot:cell(unitPrice)="data">
        {{ formatAmount(data.item.unitPrice) }}
      </template>

      <template v-slot:cell(amount)="data">
        {{ formatAmount(data.item.amount) }}
      </template>

      <template v-slot:cell(storageLocation)="data">
        {{ getStorageLabel(data.item.storageLocation) }}
      </template>

      <template v-slot:cell(attachList)="data">
        <div style="color: #4caedc" v-for="(file,index) in data.item.attachList" :key="index" @click="$viewAttach(file)">{{ file.name }}</div>
      </template>

      <template v-slot:table-colgroup="scope">
        <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{ width: field.width }"
        >
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  name: "ApmsRegCanteenPurchaseDetail",
  data() {
    return {
      storageOptions: [
        { value: '1', label: '厨房' },
        { value: '2', label: '仓库' },
        { value: '3', label: '包装车间' }
      ],
      fields1: [
        {key: 'index', stickyColumn: true, label: '序号', width: '55px'},
        {key: 'categoryName', label: '类别', width: '140px'},
        {key: 'materialName', label: '名称', width: '150px'},
        {key: 'brand', label: '品牌', width: '80px'},
        {key: 'specification', label: '规格', width: '80px'},
        {key: 'unit', label: '单位', width: '80px'},
        {key: 'quantity', label: '数量', width: '120px'},
        {key: 'unitPrice', label: '单价（元）', width: '120px'},
        {key: 'amount', label: '金额（元）', width: '110px'},
        {key: 'reviewedQuantity', label: '复核数量', width: '120px'},
        {key: 'storageLocation', label: '存库地点', width: '120px'},
      ],
      items: [],
    }
  },
  created() {
    const data = this.$route.query.data
    if (data) {
      this.items = JSON.parse(data)
    }
  },
  methods: {
    goBack() {
      this.$router.back()
    },
    formatAmount(value) {
      const num = Number(value)
      if (isNaN(num)) {
        return '0.00'
      }
      return num.toFixed(2)
    },
    getStorageLabel(value) {
      const found = this.storageOptions.find(item => item.value === value)
      return found ? found.label : ''
    },
  }
}
</script>

<style scoped>
</style>
